export default __webpack_public_path__ + "static/media/Icon-arrow-right.b05ae93e.svg";